import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CodesService {

  constructor(
    private http: HttpClient,
  ) { }

  async getIaeCodes() {
    return await lastValueFrom<any>(this.http.get(`${environment.apiUrl}/codes/get-iae-codes`));
  }

  async getCnaeCodes() {
    return await lastValueFrom<any>(this.http.get(`${environment.apiUrl}/codes/get-cnae-codes`));
  }

  async getOffices() {
    return await lastValueFrom<any>(this.http.get(`${environment.apiUrl}/codes/offices`));
  }

}
